import React from 'react'
import { useSelector } from 'react-redux'
import { ROUTE_SEO_COUNTRY, ROUTE_SEO_DEPARTMENT, ROUTE_SEO_REGION } from '../../../routes'
import { isCountry, isDepartment, isRegion } from '../../../store/address/address.helpers'
import { selectFirstAddress } from '../../../store/address/address.selectors'
import { slugify } from '../../../utils/string'
import { getImagePath } from '../../address/seo/AddressImage.utils'
import { withEmptyFallbackErrorBoundary } from '../../error/EmptyFallbackErrorBoundary'
import { useT } from '../../i18n/T'
import { generateFullRoute } from '../../router/routeUtils'
import MetaTags from '../MetaTags'

export const getMetaParams = address => {
  if (isCountry(address)) {
    const { countryCode, countryLabel } = address
    return {
      titleArgs: [countryLabel, countryLabel],
      descriptionArgs: [countryLabel, countryLabel, countryLabel],
      canonical: countryCode
        ? generateFullRoute(ROUTE_SEO_COUNTRY, {
            location: `${countryCode}-${slugify(countryLabel)}`
          })
        : null
    }
  } else if (isRegion(address)) {
    const { regionCode, regionLabel } = address
    return {
      titleArgs: [regionLabel, regionLabel],
      descriptionArgs: [regionLabel, regionLabel, regionLabel],
      canonical: regionCode
        ? generateFullRoute(ROUTE_SEO_REGION, {
            location: `${regionCode}-${slugify(regionLabel)}`
          })
        : null
    }
  } else if (isDepartment(address)) {
    const { departmentCode, departmentLabel } = address
    return {
      titleArgs: [departmentLabel, departmentLabel],
      descriptionArgs: [departmentLabel, departmentLabel, departmentLabel],
      canonical: departmentCode
        ? generateFullRoute(ROUTE_SEO_DEPARTMENT, {
            location: `${departmentCode}-${slugify(departmentLabel)}`
          })
        : null
    }
  }
}

const SeoZoneMetaManager = () => {
  const address = useSelector(selectFirstAddress)
  const { titleArgs, descriptionArgs, canonical } = getMetaParams(address) ?? {}

  const title = useT('zones.page.meta.title', titleArgs)
  const description = useT('zones.page.meta.description', descriptionArgs)

  return <MetaTags title={title} description={description} image={getImagePath(address)} canonical={canonical} />
}

export default withEmptyFallbackErrorBoundary(SeoZoneMetaManager)
